/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_SD_USER_INFO, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS } from './actionTypes';

/**
 * Updates the details in the 'ExternalUserInformation' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdUserInfoReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_USER_INFO);

/**
 * Updates the indicator of creation of details in the 'ExternalUserInformation' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdUserInfoReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_USER_INFO);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdUserInfoErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_USER_INFO);

/**
 * Updates the details in the 'ExternalUserInformation' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdUserLocalOfficeAddressReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS);

/**
 * Updates the indicator of creation of details in the 'ExternalUserInformation' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdUserLocalOfficeAddressReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdUserLocalOfficeAddressErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS);

const reducers = combineReducers({
  fetchSdUserInfo: fetchSdUserInfoReducer,

  isFetchingFetchSdUserInfo: isFetchingFetchSdUserInfoReducer,
  fetchSdUserInfoError: fetchSdUserInfoErrorReducer,

  fetchSdUserLocalOfficeAddress: fetchSdUserLocalOfficeAddressReducer,

  isFetchingFetchSdUserLocalOfficeAddress: isFetchingFetchSdUserLocalOfficeAddressReducer,
  fetchSdUserLocalOfficeAddressError: fetchSdUserLocalOfficeAddressErrorReducer,
});

export default { reducers };
